import styled from '@emotion/styled'

import { DESCRIPTIONS } from '../../../../modules/trade-approval/constants'
import { ModalHeader, SimpleModal, Space, Typography } from '../..'
import TradeDocuments from '../trade-documents'

export type TradeDocumentsModalProps = {
  onClose: () => void
  tradeDocumentationUrl: string
}

const StyledDownloadWrapper = styled.div`
  div {
    background: var(--White98);
  }
`

const TradeDocumentsModal = ({ onClose, tradeDocumentationUrl }: TradeDocumentsModalProps) => (
  <SimpleModal>
    <ModalHeader onClickClose={() => onClose()}>Trade documents</ModalHeader>
    <Space p={6}>
      <Space mb={6}>
        <Typography fontSize={13} variant="b3">
          {DESCRIPTIONS.TRADE_DOCUMENTS_DOWNLOAD}
        </Typography>
      </Space>
      <StyledDownloadWrapper>
        <TradeDocuments tradeDocumentationUrl={tradeDocumentationUrl} />
      </StyledDownloadWrapper>
    </Space>
  </SimpleModal>
)

export default TradeDocumentsModal
